import { useCartStore } from '@/ui/store/cart';
import React from 'react';
import { CartCheckoutButton } from './CartCheckoutButton';

export function BottomCheckoutButton() {
  const { isEmpty } = useCartStore();
  return (
    <div className="sticky bottom-0 left-0 w-full bg-white px-6 py-2 shadow-nuki-blured">
      <CartCheckoutButton disabled={isEmpty()} />
    </div>
  );
}
